const categoriesAnimals = [
    { min: 10, max: 16, animal: 'rat-taupe'},
    { min: 17, max: 18, animal: 'scolopendre'},
    { min: 19, max: 20, animal: 'Loutre' },
    { min: 21, max: 22, animal: 'Renard' },
    { min: 23, max: 24, animal: 'Capybara' },
    { min: 25, max: 26, animal: 'chat' },
    { min: 27, max: 28, animal: 'poney' },
    { min: 29, max: 30, animal: 'Corbeau'},
    { min: 31, max: 32, animal: 'phoque'},
    { min: 33, max: 34, animal: 'Crocodile'},
    { min: 35, max: 36, animal: 'Chevêche'},
    { min: 37, max: 38, animal: 'komodor' },
    { min: 39, max: 40, animal: 'panda' },
    { min: 41, max: 42, animal: 'Suricate'},
    { min: 43, max: 44, animal:'Ornithorynque'},
    { min: 45, max: 46, animal: 'Cerf'},
    { min: 47, max: 48, animal: 'Papillon'},
    { min: 49, max: 50, animal : 'Kangourou'},

]

export default categoriesAnimals;


const categoriesAnimals2 = [
    { number: 20, animal: 'rat-taupe' },
    { number: 21, animal: 'scolopendre' },
    { number: 26, animal: 'Capybara' },
    { number: 27, animal: 'chat' },
    { number: 28, animal: 'poney' },
    { number: 29, animal: 'Corbeau'},
    { number: 30, animal: 'phoque'},
    { number: 31, animal: 'Crocodile'},
    { number: 32, animal: 'Chevêche'},
    { number: 33, animal: 'komodor' },
    { number: 34, animal: 'panda' },
    { number: 35, animal: 'Suricate'},
    { number: 36, animal:'Ornithorynque'},
    { number: 37, animal: 'Cerf'},
    { number: 38, animal: 'Papillon'},
    { number: 39, animal : 'Kangourou'},
    { number: 40, animal: 'loutre'},

]
export {categoriesAnimals2};


const categoriesAnimals3 = [
    { min: 10, max: 15, animal: 'rat-taupe'},
    { min: 16, max: 17, animal: 'scolopendre'},
    { min: 18, max: 19, animal: 'Beluga'},
    { min: 20, max: 20, animal: 'Crocodile'},
    { min: 21, max: 21, animal: 'poney' },
    { min: 22, max: 22, animal: 'Renard' },
    { min: 23, max: 23, animal: 'Capybara' },
    { min: 24, max: 24, animal: 'chat' },
    { min: 25, max: 25, animal: 'komodor' },
    { min: 26, max: 26, animal: 'Corbeau'},
    { min: 27, max: 27, animal: 'phoque'},
    { min: 28, max: 28, animal: 'Canard'},
    { min: 29, max: 29, animal: 'Chevêche'},
    { min: 30, max: 30, animal: 'Loutre' },
    { min: 31, max: 31, animal: 'panda' },
    { min: 32, max: 32, animal: 'Suricate'},
    { min: 33, max: 33, animal:'Ornithorynque'},
    { min: 34, max: 34, animal: 'Cerf'},
    { min: 35, max: 40, animal: 'Papillon'},
    { min: 41, max: 50, animal : 'Kangourou'},

]

export { categoriesAnimals3}